module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "hero is-fullheight"
  }, [_c('div', {
    staticClass: "hero-body has-text-centered"
  }, [_c('h1', {
    staticClass: "hero-title"
  }, [_vm._v(_vm._s(_vm.$t('home.hero.title')))]), _vm._v(" "), _c('button', {
    staticClass: "play-button",
    on: {
      "click": function($event) {
        _vm.showVideo()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/icons/play-circle-outline-white.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "download-button-container"
  }, [_c('a', {
    staticClass: "download-button",
    attrs: {
      "href": "https://itunes.apple.com/app/cinenow/id1216826213"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.$t('home.hero.appStoreButton'),
      "alt": _vm.$t('home.hero.appStoreAlt')
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "download-button",
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.selectic.cinomatch"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.$t('home.hero.googlePlayButton'),
      "alt": _vm.$t('home.hero.googlePlayAlt')
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "anchor-button",
    on: {
      "click": function($event) {
        _vm.scrollToContent()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/icons/keyboard-arrow-down-white.svg"),
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('section', {
    ref: "content",
    staticClass: "features section"
  }, [_c('mobile-demo', [_c('mobile-demo-feature', {
    attrs: {
      "title": _vm.$t('home.features.feature1.title'),
      "screenshootSrc": require('../assets/images/screens/home_fr.png')
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('home.features.feature1.body')) + "\n      ")]), _vm._v(" "), _c('mobile-demo-feature', {
    attrs: {
      "title": _vm.$t('home.features.feature2.title'),
      "screenshootSrc": require('../assets/images/screens/user_fr.png')
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('home.features.feature2.body')) + "\n      ")]), _vm._v(" "), _c('mobile-demo-feature', {
    attrs: {
      "title": _vm.$t('home.features.feature3.title'),
      "screenshootSrc": require('../assets/images/screens/chat_fr.png')
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('home.features.feature3.body')) + "\n      ")])], 1)], 1), _vm._v(" "), (_vm.isVideoVisible) ? _c('div', {
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        _vm.hideVideo()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('youtube', {
    staticClass: "trailer-video",
    attrs: {
      "video-id": _vm.$t('home.hero.video'),
      "player-vars": {
        autoplay: 1
      }
    },
    on: {
      "ended": function($event) {
        _vm.hideVideo()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-close",
    on: {
      "click": function($event) {
        _vm.hideVideo()
      }
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f6680da","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 112
// module chunks = 0